import React from 'react';

import { currentStepHasOptions } from './Wizard.helpers';
import { WizardProps } from './Wizard.types';
import WizardNavigation from './WizardNavigation';
import WizardStep from './WizardStep';

const Wizard = ({
  steps,
  stepIndex,
  navigationType,
  hidePreviousButton,
  isIframed,
  onPreviousStep,
  onNextStep,
}: WizardProps) => {
  const nextButtonEnabled = !currentStepHasOptions(steps[stepIndex]);

  return (
    <div>
      {steps.map(
        (step, index) =>
          index === stepIndex && (
            <WizardStep
              {...step}
              key={index}
              navigationType={navigationType}
              hasIframe={isIframed}
            />
          )
      )}
      <WizardNavigation
        type={navigationType}
        enableNextButton={nextButtonEnabled}
        hidePreviousButton={hidePreviousButton}
        onPreviousButtonClicked={onPreviousStep}
        onNextButtonClicked={onNextStep}
      />
    </div>
  );
};

export default Wizard;
